<template>
  <div class="margin-bottom-md">
    <div
      class="tb-form-group"
      data-entity="producer-editor-toggleBackgroundColorPicker"
      data-test="displays-editor-background-colorToggle"
    >
      <label class="tb-label margin-right-xs">Background color</label>

      <colorpicker
        :color="getField('backgroundColor')"
        @change="setField('backgroundColor', $event)"
      />
    </div>

    <div class="tb-form-group flex items-center">
      <label class="tb-label margin-right-xs">Background type</label>

      <dropdown position="bottom left" class="screen-size__dropdown">
        <template #trigger>
          <button class="tb-btn tb-btn-text sm medium-em header-section" data-test="displays-editor-background-style-dropdown">{{ getField('backgroundStyle') }} <span class="fa fa-chevron-down"></span></button>
        </template>
        <template #dropdown-body>
          <ul class="screen-size__options-list">
            <li v-for="style in ['image', 'video']" :key="style">
              <button
                class="tb-btn tb-btn-text sm w-full text-left"
                :data-test="`displays-editor-background-style-${style}`"
                @click="setField('backgroundStyle', style)"
              >
                {{ style }}
              </button>
            </li>
          </ul>
        </template>
      </dropdown>
    </div>

    <div
      v-if="getField('backgroundStyle') === 'image'"
      class="tb-form-group"
    >
      <label class="tb-label margin-right-xs">Background image</label>

      <div v-if="getField('backgroundImage')" class="media-upload-wrapper">
        <div
          class="media"
          :style="{
              backgroundImage: `url('${getField('backgroundImage')}')`,
            }"
        />
        <div class="edit-media">
          <button
            class="tb-btn tb-btn-contained on-image"
            data-entity="producer-editor-editBackgroundImage"
            data-test="displays-editor-background-select"
            @click="selectAsset"
          >
            <span class="icon icon-pencil" />
          </button>

          <button
            class="tb-btn tb-btn-contained on-image"
            data-entity="producer-editor-clearBackgroundImage"
            data-test="displays-editor-background-clear"
            @click="setField('backgroundImage', '')"
          >
            <span class="icon icon-cross" />
          </button>
        </div>
      </div>

      <button
        v-else
        class="tb-btn tb-btn-contained medium-em"
        data-entity="producer-editor-setBackgroundImage"
        data-test="displays-editor-background-select"
        @click="selectAsset"
      >
        <span class="icon icon-picture margin-right-xs" />
        Choose image
      </button>
    </div>

    <div
      v-if="getField('backgroundStyle') === 'video'"
      class="tb-form-group"
    >
      <label class="tb-label margin-right-xs">Background video</label>

      <div v-if="getField('backgroundVideo')" class="media-upload-wrapper">
        <video
          class="media"
          :src="getField('backgroundVideo')"
        />
        <div class="edit-media">
          <button
            class="tb-btn tb-btn-contained on-image"
            data-test="displays-editor-background-select-video"
            @click="selectVideoAsset"
          >
            <span class="icon icon-pencil" />
          </button>

          <button
            class="tb-btn tb-btn-contained on-image"
            data-test="displays-editor-background-clear-video"
            @click="setField('backgroundVideo', '')"
          >
            <span class="icon icon-cross" />
          </button>
        </div>
      </div>

      <button
        v-else
        class="tb-btn tb-btn-contained medium-em"
        data-test="displays-editor-background-select-video"
        @click="selectVideoAsset"
      >
        <span class="icon icon-picture margin-right-xs" />
        Choose video
      </button>
    </div>
  </div>
</template>

<script>
import editingMixins from '../../../mixins/editing-mixins';

export default {
  mixins: [editingMixins],
  methods: {
    selectAsset() {
      this.$store.dispatch('toggleAssetModal', { toggled: true, type: 'image' });

      window.assetmanfn = (asset) => {
        this.setField('backgroundVideo', ''); // Clear video if image is selected
        this.setField('backgroundImage', asset.media_url);
        this.$store.dispatch('toggleAssetModal', { toggled: false, type: 'image' });
      };
    },
    selectVideoAsset() {
      this.$store.dispatch('toggleAssetModal', { toggled: true, type: 'video' });

      window.assetmanfn = (asset) => {
        this.setField('backgroundImage', ''); // Clear image if video is selected
        this.setField('backgroundVideo', asset.media_url);
        this.$store.dispatch('toggleAssetModal', { toggled: false, type: 'video' });
      };
    },
  },
};
</script>
